<template>
    <b-card>
       <div class="card-header">
           <h5 class="card-title mb-0"><b>{{ $t('client') }}</b></h5>
       </div>
       <div class="card-body">
           <div class="mb-3">
               <div class="d-flex mt-4">
                   <div class="flex-shrink-0 avatar-xs align-self-center me-3" >
                       <div :class="`avatar-title bg-primary rounded-circle fs-16 text-white`" >
                           <i :class="`bx bxs-phone`"></i>
                       </div>
                   </div>
                   <div :class="`flex-grow-1 overflow-hidden`" >
                       <p class="mb-1 fs-16">{{ $t('phone_number') }} :</p>
                       <div class="ctext-wrap" style="display:flex">
                           <div class="ctext-wrap-content d-flex">
                               <h6 :class="`fs-14 mb-0 fw-normal copy`" @click="getClient"> {{ this.form.userPhone }}</h6>
                               <i class="ri-file-copy-2-fill fs-16 copybtn text-secondary" style="margin-left: 10px;" @click="copy(this.form.userPhone)"></i>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
           <div class="mb-3" v-if="form.userName != ''">
               <div class="d-flex mt-4">
                   <div class="flex-shrink-0 avatar-xs align-self-center me-3" >
                       <div :class="`avatar-title bg-primary rounded-circle fs-16 text-white`" >
                           <i :class="`bx bxs-phone`"></i>
                       </div>
                   </div>
                   <div :class="`flex-grow-1 overflow-hidden`" >
                       <p class="mb-1 fs-16">{{ $t('name') }} :</p>
                       <div class="ctext-wrap" style="display:flex">
                           <div class="ctext-wrap-content">
                               <h6 :class="`fs-14 mb-0 fw-normal copy`" @click="copy(this.form.userName)"> {{this.form.userName == null ? this.$t('Null') : this.form.userName}}</h6>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
           <div class="mb-3" v-if="form.userEmail != ''">
               <div class="d-flex mt-4">
                   <div class="flex-shrink-0 avatar-xs align-self-center me-3" >
                       <div :class="`avatar-title bg-primary rounded-circle fs-16 text-white`" >
                           <i :class="`bx bx-comment-dots`"></i>
                       </div>
                   </div>
                   <div :class="`flex-grow-1 overflow-hidden`" >
                       <p class="mb-1 fs-16">{{ $t('mail') }} :</p>
                       <div class="ctext-wrap" style="display:flex">
                           <div class="ctext-wrap-content">
                               <h6 :class="`fs-14 mb-0 fw-normal copy`" @click="copy(this.form.userEmail)" >{{this.form.userEmail == null ? this.$t('Null') : this.form.userEmail}}</h6>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
       </div>
    </b-card>
</template>

<script>
import {copy} from '@/usabilityScripts/copy.js'

export default{
    props: ['obj'],
    data(){
        return {
            form: ''
        }
    },
    created(){
        this.form = this.obj
    },
    methods: {
        getClient() {
            // console.log('client')
            // this.$emit('getClient', this.form.userPhone)
            this.eventBus.emit('getClient', {status: true, number: this.form.userPhone, requestId: this.form.requestId, form: this.form})
        },
        copy(item){
            // копіювання
            if(copy(item) == true) {
                this.$toast.success(this.$t('Copied'));
            } else {
                this.$toast.error(`Fucking mistake, contact Borys`);
            }
            return
        },
    }
}
</script>

